import { useState, useCallback, useMemo } from 'react';
import useAutoCache from '../../hooks/useAutoCache';

// #528 (Scheibe 3 aus #313): Heutige Termine im Dashboard -- Auto-Cache ueber
// gestern 00:00 bis morgen 23:59 (wegen ganztaegiger Ueberlappungen),
// gefiltert auf heute, und die Verknuepfungen der Termine mit Tickets. Code
// unveraendert aus Dashboard.js uebernommen, Muster aus #312/#471.
//
// Die Setter gehen mit hinaus: loadDashboardData laedt die Termine beim Start
// einmal ausdruecklich (ungefiltert, bis der Cache liefert), und nach einer
// Ticket-Aenderung liest das Dashboard die Verknuepfungen neu.
export default function useTodayEvents() {

  const [events, setEvents] = useState([]);
  const [linkedCalendarEventIds, setLinkedCalendarEventIds] = useState([]);
  const [calendarEventTicketStatus, setCalendarEventTicketStatus] = useState({});

  // Event auto-cache with callback to update state - filter for today's events only
  const handleEventUpdate = useCallback((newEvents) => {
    // Helper function to parse datetime with proper timezone handling (same as CompactEventList)
    const parseDateTime = (dateTimeString) => {
      const utcDateTime = dateTimeString.endsWith('Z') ? dateTimeString : dateTimeString + 'Z';
      return new Date(utcDateTime);
    };
    
    // Filter for today's events only
    const now = new Date();
    const todayStart = new Date(now);
    todayStart.setHours(0, 0, 0, 0);
    const todayEnd = new Date(now);
    todayEnd.setHours(23, 59, 59, 999);
    
    const todaysEvents = newEvents.filter(event => {
      const eventStart = parseDateTime(event.start.dateTime);
      const eventEnd = parseDateTime(event.end.dateTime);
      
      // Show events that are happening today (start or end within today, or span across today)
      return (eventStart >= todayStart && eventStart <= todayEnd) ||
             (eventEnd >= todayStart && eventEnd <= todayEnd) ||
             (eventStart <= todayStart && eventEnd >= todayEnd);
    });
    
    setEvents(todaysEvents);
  }, []);

  // Compute a tight events fetch range (yesterday 00:00 → tomorrow 23:59) to include all-day overlaps
  const [eventsStartDate, eventsEndDate] = useMemo(() => {
    const now = new Date();
    const start = new Date(now);
    start.setDate(now.getDate() - 1);
    start.setHours(0, 0, 0, 0);
    const end = new Date(now);
    end.setDate(now.getDate() + 1);
    end.setHours(23, 59, 59, 999);
    return [start, end];
  }, []);

  const { manualRefresh: manualRefreshEvents, errorCount: eventErrorCount, isSuspended: eventsSuspended } = useAutoCache({
    type: 'events',
    enabled: true,
    onDataUpdate: handleEventUpdate,
    startDate: eventsStartDate,
    endDate: eventsEndDate,
    checkInterval: 60000 // Check every 60 seconds
  });

  return {
    events, setEvents, linkedCalendarEventIds, setLinkedCalendarEventIds,
    calendarEventTicketStatus, setCalendarEventTicketStatus, manualRefreshEvents, eventErrorCount, eventsSuspended,
  };
}
